/**
 * @generated SignedSource<<15539f0631b53e849a103beadfbba26f>>
 * @relayHash 3d838ec4c5ff9f5bf3a00d8903a733cb
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/550.0.0-2026-03-10T14:52:07.646Z/IsCountryInEuRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IsCountryInEuRefetchQuery$variables = {
  country: string;
};
export type IsCountryInEuRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationContactDetailsRefetchable_viewer">;
  };
};
export type IsCountryInEuRefetchQuery = {
  response: IsCountryInEuRefetchQuery$data;
  variables: IsCountryInEuRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "country"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "country",
    "variableName": "country"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IsCountryInEuRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "SellerApplicationContactDetailsRefetchable_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IsCountryInEuRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "kind": "ScalarField",
            "name": "isCountryInEu",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/550.0.0-2026-03-10T14:52:07.646Z/IsCountryInEuRefetchQuery",
    "metadata": {},
    "name": "IsCountryInEuRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d784e6b3e75952e98a8545039445ce2f";

export default node;
